import { AbstractCollectionDirective } from './abstract-collection.directive';
import { Component } from '@angular/core';

@Component({
  templateUrl: './geology-detail.component.html',
  styleUrls: ['./ie11-fixes.scss'],
})
export class GeologyDetailComponent extends AbstractCollectionDirective {}
